// native
import { Component, OnInit, Input, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Observable, combineLatest, ReplaySubject } from 'rxjs';
import { map, startWith, publishReplay, refCount, scan } from 'rxjs/operators';

// service
import { TagsService } from '../../../core/services/tags.service';
import { UtilityService } from '../../../core/services/utility.service';

// models
import { ICollection, IItemTag } from '../../../models';

@Component({
  selector: 'navigation-tags',
  templateUrl: './navigation-tags.component.html',
  styleUrls: ['./navigation-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationTagsComponent implements OnInit {
  @Input()
  indent = 0;

  @Input()
  collection: ICollection;

  @ViewChild('searchInput', { static: false })
  searchInput: ElementRef;

  filter$ = new ReplaySubject<string>(1);

  tags$: Observable<{ items: IItemTag[], total: number }>;

  searchTerm = '';
  expanded = false;
  pageSize = 10;
  showMoreTags = new ReplaySubject<number>(1);

  constructor(
    private tagService: TagsService,
    public changeDetectroRef: ChangeDetectorRef,
    public utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.tags$ = combineLatest(
      this.tagService.getTags(this.collection.id),
      this.showMoreTags.pipe(startWith(this.pageSize), scan((acc, curr) => acc + curr)),
      this.filter$.pipe(startWith(''))
    ).pipe(
      map(([ tags, limit, term ]) => {
        setTimeout(() => {
          this.searchInput?.nativeElement.blur();
          this.searchInput?.nativeElement.focus();
        }, 10);
        const items = tags.filter(value => {
          return value.name.toLocaleLowerCase().includes(term.toLocaleLowerCase());
        });
        return {
          items: items.sort((a, b) => {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
          }).slice(0, limit),
          total: items.length
        };
      }),
      publishReplay(1),
      refCount()
    );
  }

  setExpanded(value = true, focusSearchInput = false) {
    this.expanded = value;
    if (value && focusSearchInput) {
      setTimeout(() => {
        this.searchInput?.nativeElement.focus();
      }, 10);
    }
  }

  trackTagById(index: number, tag: IItemTag) {
    return tag.id;
  }
}
